import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_PROFESIONES,
  ALL_PROFESIONES,
  LOADING_ALL_PROFESIONES,
} from './ProfesionesReducer';
import {
  deleteProfesionesService,
  allProfesionesService,
  oneProfesionesService,
  saveProfesionesService,
} from './ProfesionesService';

export const allProfesionesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_PROFESIONES, payload: true });
    const res = await allProfesionesService(params);
    dispatch({ type: ALL_PROFESIONES, payload: res.data });
    dispatch({ type: LOADING_ALL_PROFESIONES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PROFESIONES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveProfesionesAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveProfesionesService(id, data);
    notify(res.data.message);
    await allProfesionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoProfesionesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PROFESIONES, payload: data });
};

export const oneProfesionesAction = async (dispatch, id) => {
  try {
    const res = await oneProfesionesService(id);
    await setActivoProfesionesAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteProfesionesAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteProfesionesService(id);
    notify(res.data.message);
    await setActivoProfesionesAction(dispatch, null);
    await allProfesionesAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
